module.exports = __webpack_public_path__ + "static/media/avatar.6eb26c0f.jpg";